export class WorklinePrototyp{
  public id = null
  public name = null
  public description = null
  public dauer = 0
  public monteur_id = null
  public von = null
  public bis = null
  public order_id = null;

  constructor(){}
}



// WEBPACK FOOTER //
// ./src/assets/shared/workline.object.ts